import { extractErrorsFromApi } from '../../../common/helpers';
import { toast } from 'react-toastify';
import { useApproveUserMutation } from '../user.api-slice';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  id: string;
}

const ApproveUser: React.FC<IProps> = ({ id }) => {
  const [approveResource, { isSuccess, isError, error }] = useApproveUserMutation();
  const { t } = useTranslation();

  const handleApprove = (id: string): void => {
    void approveResource(id);
  };

  useEffect(() => {
    if (isSuccess) {
      toast(t('user.approve.success'));
    }
    if (isError && error != null) {
      const message = extractErrorsFromApi(error).toString();
      toast(message);
    }
  }, [isSuccess, isError, error]);

  return (
    <>
      <button
        onClick={() => {
          handleApprove(id);
        }}
        className="px-2 text-gray-50 bg-[#1D8A43] text-sm text-center rounded-md"
      >
        Approve
      </button>
    </>
  );
};

export default ApproveUser;
